<!--资料安全密码-->
<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px" size="mini">
      <div class="row-wrap">
        <h3 style="padding-left:15px;">个人资料安全密码（非登录密码）</h3>
        <el-row v-for="(pwd, idx) in form.strongPwd" :key="idx">
          <el-col :xs="24" :sm="24" style="padding:15px;">
            <el-link style="margin-top:8px;" type="danger" disabled>
              {{ msg('密码规则：密码长度大于4位，仅可包含字母、数字及以下特殊字符：~!@#$%^&*-_.') }}
            </el-link>
            <br/>
            <el-link style="margin-top:8px;" type="danger" disabled>
              {{ msg('注意：个人安全密码一旦设置，无法清除，当密码框为空时，更新不会有任何改变，如需清除密码，请联系管理员！') }}
            </el-link>
          </el-col>
          <el-col :xs="24">
            <el-form-item :label="msg('新密码')">
              <el-input v-model="pwdCover" size="small" style="width:200px" type="text" id="pwd"
                        placeholder="请输入新的个人安全密码"
                        autocomplete="off" @input="setPassword"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item :label="msg('确认密码')">
              <el-input v-model="confirmPwdCover" type="text" size="small" style="width:200px" id="confirmPwd"
                        placeholder="请再次输入安全密码"
                        autocomplete="off" @input="setConfirmPassword"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
        <el-button type="primary" size="mini" @click="update"><i
            class="el-icon-check"></i><span>{{ msg('确定') }}</span>
        </el-button>
      </div>
    </el-form>
    <el-dialog :title="msg('验证旧安全密码')" :visible.sync="strongPwdVisiable" :close-on-click-modal="false">
      <StrongPwd v-on:close-dg="kit.strongAuthData.closeEvent"/>
    </el-dialog>
  </div>
</template>

<script>
import StrongPwd from "@/views/sys/StrongPwd.vue";
export default {
  name: "UserSettingStrongPwd",
  components:{
    StrongPwd,
  },
  data() {
    return {
      xgroup: 'strongPwd',  //电子秤group
      form: {
        strongPwd: [],
      },
      password: '',
      pwdCover: '',
      confirmPassword: '',
      confirmPwdCover: '',
      strongPwdVisiable: false, //个人安全密码验证窗
    }
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      _this.form.strongPwd = [];

      let strongPwd = data; //材积计算
      //个人安全密码
      if (strongPwd.length > 0) {
        var item = strongPwd[0];
        item.xvalue = '';
        item.hasValue = true;
        _this.form.strongPwd.push(item);
      } else {
        _this.form.strongPwd.push({
          id: null,
          xgroup: 'strongPwd',
          xkey: 'strongPwd',
          xtype: 1,
          owner: null,
          xvalue: ''
        });
      }
    },
    setPassword(val) {
      let reg = this.$kit.strongAuthData.reg; // 只允许输入字母和数字
      let nDot = /[^●]/g; // 非圆点字符
      let index = -1; // 新输入的字符位置
      let lastChar = void 0; // 新输入的字符
      let realArr = this.password.split(''); // 真实密码数组
      let coverArr = val.split(''); // 文本框显示密码数组
      let coverLen = val.length; // 文本框字符串长度
      let realLen = this.password.length; // 真实密码长度
      // 找到新输入的字符及位置
      coverArr.forEach((el, idx) => {
        if (nDot.test(el)) {
          index = idx;
          lastChar = el;
        }
      });
      // 判断输入的字符是否符合规范，不符合的话去掉该字符
      // if (lastChar && reg.test(lastChar)) {
      //   this.errMsg = '无效字符：' + lastChar;
      //   coverArr.splice(index, 1);
      //   this.pwdCover = coverArr.join('');
      //   return;
      // }
      if (realLen < coverLen) {
        // 新增字符
        realArr.splice(index, 0, lastChar);
      } else if (coverLen <= realLen && index !== -1) {
        // 替换字符（选取一个或多个字符直接替换）
        realArr.splice(index, realLen - (coverLen - 1), lastChar);
      } else {
        // 删除字符，因为 val 全是 ● ，没有办法匹配，不知道是从末尾还是中间删除的字符，删除了几个，不好对 password 处理，所以可以通过光标的位置和 val 的长度来判断
        let pos = document.getElementById('pwd').selectionEnd; // 获取光标位置
        realArr.splice(pos, realLen - coverLen);
      }
      // 将 pwdCover 替换成 ●
      this.pwdCover = val.replace(/\S/g, '●');
      this.password = realArr.join('');
    },
    setConfirmPassword(val) {
      let reg = this.$kit.strongAuthData.reg; // 只允许输入字母和数字
      let nDot = /[^●]/g; // 非圆点字符
      let index = -1; // 新输入的字符位置
      let lastChar = void 0; // 新输入的字符
      let realArr = this.confirmPassword.split(''); // 真实密码数组
      let coverArr = val.split(''); // 文本框显示密码数组
      let coverLen = val.length; // 文本框字符串长度
      let realLen = this.confirmPassword.length; // 真实密码长度
      // 找到新输入的字符及位置
      coverArr.forEach((el, idx) => {
        if (nDot.test(el)) {
          index = idx;
          lastChar = el;
        }
      });
      // 判断输入的字符是否符合规范，不符合的话去掉该字符
      // if (lastChar && reg.test(lastChar)) {
      //   this.errMsg = '无效字符：' + lastChar;
      //   coverArr.splice(index, 1);
      //   this.pwdCover = coverArr.join('');
      //   return;
      // }
      if (realLen < coverLen) {
        // 新增字符
        realArr.splice(index, 0, lastChar);
      } else if (coverLen <= realLen && index !== -1) {
        // 替换字符（选取一个或多个字符直接替换）
        realArr.splice(index, realLen - (coverLen - 1), lastChar);
      } else {
        // 删除字符，因为 val 全是 ● ，没有办法匹配，不知道是从末尾还是中间删除的字符，删除了几个，不好对 password 处理，所以可以通过光标的位置和 val 的长度来判断
        let pos = document.getElementById('pwd').selectionEnd; // 获取光标位置
        realArr.splice(pos, realLen - coverLen);
      }
      // 将 pwdCover 替换成 ●
      this.confirmPwdCover = val.replace(/\S/g, '●');
      this.confirmPassword = realArr.join('');
    },
    update() {
      let datas = [];
      //构建个人安全密码设置
      if (this.form.strongPwd.length > 0) {
        var pwd = this.password;
        if (pwd) {
          if (pwd.length < 4) {
            this.$message.error(this.msg("个人安全密码太短！"))
            return;
          }
          var reg = this.$kit.strongAuthData.reg;
          if (reg.test(pwd)) {
            this.$message.error(this.msg("个人安全密码包含无效字符！"))
            return;
          }
          var confirmPwd = this.confirmPassword;
          if (!confirmPwd) {
            this.$message.error(this.msg("请输入确认安全密码！"))
            return;
          }
          if (pwd != confirmPwd) {
            this.$message.error(this.msg("两次输入的密码不一致！"))
            return;
          }
          this.form.strongPwd[0].xvalue = this.password;
          datas.push(this.form.strongPwd[0]);
        }
      }
      var _this = this;
      if (datas.length > 0) {
        if (datas[0].hasValue) {
          _this.$kit.strongAuthData.closeEvent = function (type) {
            _this.strongPwdVisiable = false;
            if (type) {
              _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + _this.xgroup, datas).then((result) => {
                _this.$message(result.msg)
              });
            }
          };
          _this.strongPwdVisiable = true;
        } else {
          _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + _this.xgroup, datas).then((result) => {
            var tmp = _this.form.strongPwd[0];
            tmp.hasValue = true;
            _this.$set(_this.form.strongPwd, 0, tmp);
            _this.$message(result.msg)
          });
        }
      }
    }
  }
}
</script>

<style scoped>

</style>